import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useSessionStore } from '@entities/session';
import { ROUTES } from '@shared/config/routes';
import { loginWithPassword } from '../api/login';

export function useLogin() {
  const navigate = useNavigate();
  const setAuthenticated = useSessionStore((s) => s.setAuthenticated);

  return useMutation({
    mutationFn: ({ identity, password }: { identity: string; password: string }) =>
      loginWithPassword(identity, password),
    onSuccess: ({ tokens, identity }) => {
      setAuthenticated(tokens, identity);
      navigate(ROUTES.dashboard, { replace: true });
    },
  });
}
